export default "__VITE_ASSET__DLO_oSlK__"